import axios from 'axios';
import { getTokenCredentials } from '../../../Shared/functions';
import { BASE_API } from '../../../Shared/Constants';

export function getConcepts(body) {
    return axios.post(BASE_API + 'api/concept/getlist', body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
        throw error.response.data.message;
    });
}

export function createOrUpdateConcept(body) {
    return axios.post(BASE_API + 'api/concept/register', body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
        throw error.response.data.message;
    });
}